export const articleListStyles = {
  list: "my-2 flex flex-col gap-3",
  item: "overflow-hidden rounded-2xl border border-border p-4 shadow-sm",
  title: "text-sm font-semibold leading-tight text-strong",
  titleLink: "text-sm font-semibold leading-tight text-strong underline-offset-2 hover:underline",
  timestamp: "mt-0.5 text-xs text-subtle",
  body: "mt-2 text-sm text-mid [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5 [&_a]:underline",
};
